/**
 * Generate JSON-LD structured data for creator profile
 */
export function generateCreatorStructuredData(creator: {
  id: string;
  displayName: string;
  description: string;
  avatar?: string;
  website?: string;
  username: string;
  patronCount: number;
  createdAt: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Person',
    '@id': `${window.location.origin}/creator/${creator.username}`,
    name: creator.displayName,
    description: creator.description,
    image: creator.avatar,
    url: creator.website || `${window.location.origin}/creator/${creator.username}`,
    identifier: creator.id,
    sameAs: creator.website ? [creator.website] : [],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      ratingCount: creator.patronCount.toString(),
    },
  };
}

/**
 * Generate JSON-LD for post/article
 */
export function generatePostStructuredData(post: {
  id: string;
  title?: string;
  content: string;
  createdAt: string;
  creator: { username: string; displayName: string };
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    '@id': `${window.location.origin}/post/${post.id}`,
    headline: post.title || post.content.slice(0, 100),
    description: post.content.slice(0, 200),
    datePublished: post.createdAt,
    author: {
      '@type': 'Person',
      name: post.creator.displayName,
      url: `${window.location.origin}/creator/${post.creator.username}`,
    },
  };
}

/**
 * Generate OpenGraph image URL (placeholder - should use actual OG image service)
 */
export function generateOGImageUrl(creator?: { displayName?: string; avatar?: string }) {
  // In production, generate OG image via service
  return creator?.avatar || '/default-og-image.png';
}


